import React from 'react'

export default function AAvatar(props) {
  return (
    <span className={`flex items-center justify-center text-xs text-red-500 font-semibold bg-red-100 h-6 px-2 rounded-full ml-auto ${props.className}`}> {props.num} </span>
  )
}
